import React from 'react';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { Link } from '@/Framework/Router/Next/Link';
import { getDealRoute } from '@/finsight/Router/RouteWithRedirect/getNewRoute';
import {
  getBondName,
  getFormattedBond,
} from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/FormSteps/heplers';
import { IPosition } from '@/finsight/domain/vo/PortfolioMonitor/ICreatePortfolioFormState';

import cellStyles from '@/finsight/ui/common/components/TableCells/styles.scss';

interface IProps {
  row: IPosition,
}

const BondNameCell = (props: IProps) => {
  const { row } = props;
  const bond = row?.bond;

  if (bond?.customBondName) {
    return (
      <Tooltip content={ bond.customBondName }>
        <span className={ cellStyles.nameCell }>{ bond.customBondName }</span>
      </Tooltip>
    );
  }

  if (bond?.dealId) {
    const formattedBond = getFormattedBond(bond);
    const dealRoute = getDealRoute(formattedBond);
    return (
      <Link to={ dealRoute } target="_blank" dataTest="bondName">
        { getBondName(bond) }
      </Link>
    );
  }

  return bond?.label || '-';
};

export default BondNameCell;
